import { INBOUND_CONTACT_NUMBER, SEO_FORM_COUPON_DATA, SHOW_INBOUND_CALL, SHOW_SEO_LEADGEN, SHOW_SEO_LEAVE_INTENT } from "../../../config/constants";
import { SEO_PAGE_NAME, UPDATE_CAR_TYPE, UPDATE_CITY_PAGE_DATA, UPDATE_PAGE_TYPE, UPDATE_ROUTE_PAGE_DATA, UPDATE_SELECTED_CAB, UPDATE_SRC_FROM_PARAMS } from "./seo-action-types";
import { IResultsStoreState } from "./types";

const initialState: IResultsStoreState = {
  results: {},
  reviews: [],
  filters: {},
  faq: {
    faq_heading: '',
    faq_content: []
  },
  selectedCab: {},
  src: '',
  dest: '',
  seo_meta: null,
  isFilterApplied: false,
  top_routes_from_src: [],
  top_routes_from_src_title: "",
  top_routes_to_dest: [],
  top_routes_to_dest_title: "",
  benefits: null,
  lpg: null,
  place_information: '',
  seo_content: '',
  templatized_content: '',
  way: '',
  car_type: '',
  isSeoPage: false,
  interlinking: [],
  hardReloadFlag: false,
  cacheFor: 0,
  hideLob: false,
  airportParams: null,
  airportType: '',
  isResultsLoaded: false,
  carType: '',
  queryFields: [],
  showSEOLeadgen:false,
  startDate:'',
  pageType:'',
  packageCarousel: [],
  seoPageName: '',
  static_rental_data: [],
  static_table_data: [],
  static_rental_table_data: [],
  dynamic_footer_data: [],
  aggregate_ratings: {},
  schema_min_fare: -1,
  seo_multi_city: false,
  route_info: {
    title: '',
    table: []
  }
};

export default function SeoPageReducer(state = initialState, action) {
  switch (action.type) {

    case UPDATE_ROUTE_PAGE_DATA:
      return {
        ...state,
        results: action?.results,
        hideLob: action?.hideLob,
        reviews: action?.voy_data?.reviews,
        seo_meta: action?.seo_meta,
        top_routes_from_src: action?.top_routes_from_src,
        top_routes_from_src_title: action?.top_routes_from_src_title,
        top_routes_to_dest: action.top_routes_to_dest,
        top_routes_to_dest_title: action.top_routes_to_dest_title,
        rental_data: action?.rental_data,
        faq: action?.faq,
        benefits: action?.benefits,
        lpg: action?.lpg,
        place_information: action?.place_information,
        seo_content: action?.seo_content,
        templatized_content: action?.templatized_content,
        interlinking: action?.interlinking,
        packageCarousel: action?.data?.package_carousel,
        dynamic_footer_data: action?.dynamic_footer_data,
        aggregate_ratings: action?.aggregate_ratings,
        schema_min_fare: action?.schema_min_fare,
        route_info: action?.route_info,
        seo_multi_city: action?.seo_multi_city
      }

    case "UPDATE_QUERY_FIELDS_DATA":
      return {
        ...state,
        queryFields: action?.queryFields,
      }

      case UPDATE_CITY_PAGE_DATA:
        return {
          ...state,
          reviews: action?.voy_data?.reviews,
          seo_meta: action?.seo_meta,
          top_routes_from_src: action?.top_routes_from_src,
          top_routes_from_src_title: action?.top_routes_from_src_title,
          top_routes_to_dest: action.top_routes_to_dest,
          top_routes_to_dest_title: action.top_routes_to_dest_title,
          rental_data: action?.rental_data,
          faq: action?.faq,
          benefits: action?.benefits,
          lpg: action?.lpg,
          place_information: action?.place_information,
          seo_content: action?.seo_content,
          interlinking: action?.interlinking,
          static_rental_data: action?.static_rental_data,
          static_table_data: action?.static_table_data,
          static_rental_table_data: action?.static_rental_table_data,
          dynamic_footer_data: action?.dynamic_footer_data,
          aggregate_ratings: action?.aggregate_ratings,
          schema_min_fare: action?.schema_min_fare,
          seo_multi_city: action?.seo_multi_city
        }

    case "UPDATE_SRC_DEST_FROM_PARAMS":
      return {
        ...state,
        src: action?.data?.src,
        dest: action?.data?.dest,
        isSeoPage: true,
        hardReloadFlag: action?.data?.hardReloadFlag,
        cacheFor: action?.data?.cacheFor,
        carType: action?.data?.carType,
        pageType:action?.data?.pageType
      }

    case UPDATE_PAGE_TYPE:
      return {
        ...state,
        pageType:action?.data?.pageType
      }
    case UPDATE_CAR_TYPE:
      return {
        ...state,
        car_type: action.seoCarType
      }

    case UPDATE_SRC_FROM_PARAMS:
      return {
        ...state,
        src: action?.data?.src,
        way: action?.data?.way,
        carType: action?.data?.carType,
        isSeoPage: true,
        hardReloadFlag: action?.data?.hardReloadFlag,
        cacheFor: action?.data?.cacheFor
      }

    case "UPDATE_DEST_FROM_PARAMS":
      return {
        ...state,
        dest: action?.data?.dest,
        way: action?.data?.way,
        carType: action?.data?.carType,
        isSeoPage: true,
        hardReloadFlag: action?.data?.hardReloadFlag,
        cacheFor: action?.data?.cacheFor
      }

    case "UPDATE_AIRPORT_FROM_PARAMS":
      return {
        ...state,
        airportParams: action?.data?.airportParams,
        isSeoPage: true,
        hardReloadFlag: action?.data?.hardReloadFlag,
        cacheFor: action?.data?.cacheFor,
        airportType: action?.data?.airportType
      }

    case UPDATE_SELECTED_CAB: {
      return {
        ...state,
        selectedCab: action.selectedCab
      }
    }
    case "UPDATE_RESULTS":
      return {
        ...state,
        results: action.results,
        isFilterApplied: false
      };
    case "UPDATE_FILTERS":
      return {
        ...state,
        filters: action.filters,
        // isFilterApplied: true
      };
    case "UPDATE_LOADER":
      return {
        ...state,
        results: {
          ...state.results,
          vehicle_data: [],
        },
      };
    case 'CLEAR_FILTER': {
      return {
        ...state,
        results: {},
        filters: {}
      };
    }

    case "UPDATE_SRC_DEST_DATE":
      return {
        ...state,
        src: action.src,
        dest: action.dest,
        startDate:action.startDate
      }
    case SHOW_SEO_LEADGEN:
      return {
        ...state,
        showSEOLeadgen: action.showSEOLeadgen
      }
    case SEO_PAGE_NAME:
      return {
        ...state,
        seoPageName: action.seoPageName
      }
    case SHOW_INBOUND_CALL:
       return{
        ...state,
        showInboundCall: action.showInboundCall
       }
    case INBOUND_CONTACT_NUMBER: 
        return {
          ...state,
          contactNumber: action.contactNumber
        }
    case "UPDATE_CHAR_DHAM_DATA" :
      return {
        ...state,
        charDhamData: action.data?.charDhamData,
        seo_meta: action.data?.seo_meta,
        src: action.data?.source,
        dest: action.data?.destination,
        faq: action.data?.faqs
      }
    case SHOW_SEO_LEAVE_INTENT:
      return {
        ...state,
        showSEOLeaveIntentForm: action.showSEOLeaveIntent
      }
    case SEO_FORM_COUPON_DATA: 
      return {
        ...state,
        seoFormCouponData: action.seoFormCouponData
      }
    default:
      return state;
  }
}
